import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
  overflow-y: auto;
  display: block;
  @media (max-width: 601px) {
    width: 100%;
    margin-left: 0;
    height: 100%;
  }
`;

export const MenuContainer = styled.div`
  margin-top: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > p {
    font-size: 18px;
    font-weight: 700;
    color: var(--color-primary);
  }
`;

export const MenuItemContainer = styled.div`
  margin: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  footer {
    height: 50px;
    background-color: #fff;
    filter: drop-shadow(0px -4px 4px rgba(0, 0, 0, 0.25));
    margin-top: 242px;
  }

  .card {
    width: 250px;
    height: 210px;
    margin: 20px;
    background: var(--linear-blue);
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    color: #fff;

    > P {
      margin-top: 20px;
      font-size: 24px;
      font-weight: 500;
    }
  }
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  @media (max-width: 1025px) {
    display: block;
  }
`;

export const Infos = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContainerGraph = styled.div`
  width: 100%;
  display: flex;
`;
